import { SearchDeeplink } from 'store/railsBuilder/reducer.types';

export default function getSearchDeeplinkItem(item: SearchDeeplink) {
    if (!item || !item.links || !item.links.length) {
        return undefined;
    }

    return item.links[0];
}
